var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_card"},[_c('h4',{staticClass:"chart_title m-0"},[_vm._t("chart_title")],2),_c('apexchart',{attrs:{"type":"bar","height":"380px","options":_vm.barChartOptions,"series":_vm.barChartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }